import * as PIXI from "pixi.js";
import Layers from "../../../../../src/layers/Layers";
import { eventBus, EnumEventBus } from "../managers/EventBus";
import { Coord } from "../../../../../src/types/Interface";
import { PURPLE_COLORS } from "../types/Config";
import addInteractivity from "../../../../../src/utils/addInteractivity";
import { CustomCursorType } from "../../../../../src/entities/UI/CustomCursor/CustomCursor";


export default class TangentRatioButton extends PIXI.Graphics {
  private Layers = Layers.getInstance();

  private index: number
  private fillColor: number = PURPLE_COLORS[0];
  private strokeColor: number = PURPLE_COLORS[1];

  constructor(index: number) {
    super();
    this.index = index;

    this.addInteractivity();
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.UI.addChild(this);

  private addInteractivity() {
    const setSltdTPIndex = () => eventBus.emit(EnumEventBus.setSltdTPIndex, this.index);
    addInteractivity(
      this,
      { handleDownFunc: setSltdTPIndex },
      CustomCursorType.target
    );
  }
  draw(coord: Coord, selected: boolean) {
    const r = 14;
    const strokeW = 3;
    this
      .clear()
      .circle(coord.x, coord.y, r + (selected ? strokeW / 2 : 0));

    selected
      ? this.fill(this.fillColor)
      : this
        .fill(0xFFFFFF)
        .stroke({ color: this.strokeColor, width: strokeW });
  }
}